import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter, TitleStrategy, withComponentInputBinding } from '@angular/router';
import { AppTitleStrategy } from './core/title-strategy';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { OAuthModule, OAuthService, OAuthStorage } from 'angular-oauth2-oidc';
import { Idle, IdleExpiry, SimpleExpiry } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { routes } from './app.routes';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { errorHandlerInterceptor } from './core/interceptors/error-handler.interceptor';
import { environment } from '../environments/environment';
import { authConfig } from './core/auth/auth.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([tokenInterceptor, errorHandlerInterceptor]),
    ),
    importProvidersFrom(
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: [environment.API_BASE_URL],
          sendAccessToken: true,
        },
      }),
    ),
    { provide: OAuthStorage, useValue: localStorage },
    provideAppInitializer(() => {
      const oauthService = inject(OAuthService);
      oauthService.configure(authConfig);
      oauthService.setupAutomaticSilentRefresh();
    }),
    Idle,
    Keepalive,
    { provide: IdleExpiry, useClass: SimpleExpiry },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
  ],
};
